import { onMounted, onBeforeUnmount, reactive, toRefs } from 'vue';

export default function useParallax(intensity = 30) {
  const position = reactive({ x: 0, y: 0 });

  function handleMouseMove(event) {
    const { innerWidth, innerHeight } = window;
    position.x = -((event.clientX / innerWidth - 0.5) * intensity);
    position.y = -((event.clientY / innerHeight - 0.5) * intensity);
  }

  onMounted(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('mousemove', handleMouseMove, { passive: true });
    }
  });

  onBeforeUnmount(() => {
    if (typeof window !== 'undefined') {
      window.removeEventListener('mousemove', handleMouseMove);
    }
  });

  return toRefs(position);
}
